var universal_sorting = {
	// selectors: { },

	init: function () {
		var self = this;

		const startDate = moment();
		const endDate = moment("9999-12-31", "YYYY-MM-DD");		
		
		if( document.querySelector('.js-universal_sorting') ) {	
			let articles = document.querySelectorAll('.js-universal_sorting .js-universal_sorting__tile');

			const filteredArticles = Array.from(articles);

			filteredArticles.forEach(article => {
				if (!article.querySelector("[data-datesjson]")) { return; }
			
				let datesJson = article.querySelector(".js-openEventDates[data-datesjson]").getAttribute('data-datesjson');
				if (datesJson != null) {
					const datesArray = JSON.parse(datesJson.replace(/&quot;/g, '"'));
		
					const upcomingDates = datesArray
						.map(dateRange => {
							const [day, month, year] = dateRange[0].split(" ")[0].split("-");
							const time = dateRange[0].split(" ")[1];
							const date = moment(`${day}-${month}-${year} ${time}`, 'DD-MM-YYYY HH:mm');
							
							return { original: dateRange, date }; // Uložíme celou řadu `dateRange` jako `original`
						})
						.filter(({ date }) => {
							const isValid = date.isValid();
							const isInRange = date.isBetween(moment(startDate, 'DD-MM-YYYY'), moment(endDate, 'DD-MM-YYYY'), 'day', '[]');
							return isValid && isInRange;
						})
						.sort((a, b) => a.date - a.date);
					
					if (upcomingDates.length > 0) {
						const nearestDateRange = upcomingDates[0].original;
						const [startDate, endDate] = nearestDateRange;
			
						// Formátujeme data přes moment.js pro správný výstup
						let formattedStartDate = moment(startDate, 'DD-MM-YYYY HH:mm').format('DD. MM. YYYY, HH:mm');
						let formattedEndDate = moment(endDate, 'DD-MM-YYYY HH:mm').format('DD. MM. YYYY, HH:mm');

						let formattedStartDateCalendar = moment(startDate, 'DD-MM-YYYY HH:mm').format('DD. MM. YYYY');
						let formattedEndDateCalendar = moment(endDate, 'DD-MM-YYYY HH:mm').format('DD. MM. YYYY');

						formattedStartDate = formattedStartDate.replaceAll( ', 00:00', '' ).replaceAll( ', 23:59', '' );
						formattedEndDate = formattedEndDate.replaceAll( ', 00:00', '' ).replaceAll( ', 23:59', '' );
						if( formattedStartDateCalendar == formattedEndDateCalendar ) {
							formattedEndDate = '';
						}
						else {
							formattedEndDate = "–" + formattedEndDate;
						}
						article.querySelector(".js-showDateTime").textContent = `${formattedStartDate}${formattedEndDate}`;
					}
				}
			});

			filteredArticles.forEach(article => {
				const aDatesRaw = article.dataset.event_date ? article.dataset.event_date.split(',') : [];

				const aDates = aDatesRaw
					.map(date => moment(date, 'DD-MM-YYYY').startOf('day'))
					.filter(date => date.isValid())
					.sort((a, b) => a.valueOf() - b.valueOf()); 
				
				const referenceDate = moment(startDate, 'DD-MM-YYYY').startOf('day');
				
				const aFirstDate = aDates.find(date => date.isSameOrAfter(referenceDate)) 
					|| aDates[0] // Pokud neexistuje, vezmeme první dostupné
					|| moment('9999-12-31', 'YYYY-MM-DD');
					
				article.dataset.sortingDate = aFirstDate.format('YYYY-MM-DD');
			});
			

			// Provede samotné třídění
			filteredArticles.sort((a, b) => {
				const aPriority = a.dataset.priority === "1";
				const bPriority = b.dataset.priority === "1";

				if (aPriority && bPriority) {
					const aOrder = parseInt(a.dataset.order, 10) || 0;
					const bOrder = parseInt(b.dataset.order, 10) || 0;
					return aOrder - bOrder;
				}

				if (aPriority) return -1;
				if (bPriority) return 1;

				// Načteme data-sorting-date a převedeme na moment pro správné porovnání
				const aDate = moment(a.dataset.sortingDate, 'YYYY-MM-DD');
				const bDate = moment(b.dataset.sortingDate, 'YYYY-MM-DD');

				return aDate.isBefore(bDate) ? -1 : aDate.isAfter(bDate) ? 1 : 0;
			});

			// Přesuneme prvky do kontejneru
			let container = document.querySelector('.js-universal_sorting');
			if (container) {
				filteredArticles.forEach(article => {
					container.appendChild(article);
				});
			}


			filteredArticles.forEach(article => {
				if( !article.querySelector(".product__dates") ) {
					return;
				}
				
				let soldOutDateButHaveMore = false;
				const productDates = article.querySelector(".product__dates").dataset.product_dates ? JSON.parse(article.querySelector(".product__dates").dataset.product_dates.replace(/&quot;/g, '"')) : [];
				if( !productDates.length ) {
					return;
				}

				if( productDates.length > 1 ) {
					jQuery.each( productDates, function( index, event ) {
						if( index == 0 && event[ 'spots' ] > 0 ) {
							return; // break;
						}

						if( index > 0 && event[ 'spots' ] > 0 ) {
							soldOutDateButHaveMore = true;
							return; // break;
						}
					});
				}

				const adjustedEndDate = moment(endDate, 'DD-MM-YYYY').endOf('day');
				
				let matchingDate = productDates.find(pd => moment(pd.date, 'YYYY-MM-DD HH:mm').isBetween(moment(startDate, 'DD-MM-YYYY'), adjustedEndDate, null, '[]'));

				if (!matchingDate) {
					matchingDate = productDates[productDates.length - 1];
				}

				if (matchingDate) {
					const dateElement = article.querySelector('.product__dates span');
					const stockElement = article.querySelector('.stock');

					if (dateElement) {
						dateElement.textContent = matchingDate.date_formatted;
					}

					if( stockElement ) {
						let itemStockText = matchingDate.spots == 0 ? `${pctVars.l18n.booking.state[1]}` : `${pctVars.l18n.booking.state[0]} ${matchingDate.spots}`;

						if( matchingDate.spots == 0 && soldOutDateButHaveMore ) {
							itemStockText = pctVars.l18n.booking.state[3]; 
						}

						if( ! matchingDate.status ) {
							itemStockText = pctVars.l18n.booking.state[2];
						}

						stockElement.textContent =  itemStockText;
					}
				}
			});
		
		}			
	},
};

export { universal_sorting };